module.exports = __webpack_public_path__ + "img/privacy-1.6a337ee4.png";